import AsyncCreatableSelect, { AsyncCreatableProps } from "react-select/async-creatable";
import { GroupBase } from "react-select";

type Props<Option = unknown, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> = AsyncCreatableProps<Option, IsMulti, Group>;

export default function RichFormSelectCreatable(props: Props) {
  return <AsyncCreatableSelect {...props} />;
}
